module.exports = __webpack_public_path__ + "img/logoC28_primary.cf111231.png";